var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDesktop)?_c('div',{class:_vm.appClass,attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.fullPath}),_c('app-loading-overlay'),_c('api-error-modal'),_c('inline-notification-modal')],1):_c('div',{staticClass:"mobile"},[_c('mobile-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }